import React from 'react'
import { Article, ScreenContainer } from "smooth-doc/components";

function PolicyLinks() {
  return (
    <div className="policies">
      <p>
        <a href="https://pathcore.com/terms-conditions">Terms and Conditions</a>
        {" | "}
        <a href="https://pathcore.com/use-policy">Use Policy</a>
        {" | "}
        <a href="https://pathcore.com/privacy-policy">Privacy Policy</a>
      </p>
    </div>
  );
}

function Copyright() {
  const year = new Date().getFullYear();
  return (
    <div className="copyright">
      <p>Copyright &copy; 2021-{year} Pathcore All Rights Reserved</p>
      <p>
        Pathcore, PathcoreFlow, PathcoreLive, PathcoreUnity,
        PathcoreScholar, PathcoreSedeen are trademarks of Pathcore Inc.
      </p>
    </div>
  );
}

export function Footer() {
  return (
    <ScreenContainer className='footer-sc'>
      <Article>
        <div className='footer'>
          <PolicyLinks />
          <Copyright />
        </div>
      </Article>
    </ScreenContainer>
  );
};
